var _defs, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.72 124.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e03616;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 69.31,
    x2: 27.71,
    y2: 97.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.76,26.05A10.25,10.25,0,0,0,155,18.3a10.51,10.51,0,0,0-3.24-7.84A10.67,10.67,0,0,0,144,7.22a11,11,0,0,0-7.84,3.24L92.9,53.82,49.55,10.46A10.71,10.71,0,0,0,41.8,7.22,11.06,11.06,0,0,0,30.72,18.3,10.71,10.71,0,0,0,34,26.05L77.32,69.4,34,112.67a11,11,0,0,0-3.24,7.84A10.67,10.67,0,0,0,34,128.26a10.51,10.51,0,0,0,7.84,3.24,10.25,10.25,0,0,0,7.75-3.24L92.9,85l43.27,43.27A10.54,10.54,0,0,0,144,131.5a11.06,11.06,0,0,0,11-11,10.54,10.54,0,0,0-3.24-7.84L108.49,69.4Z",
    transform: "translate(-28.28 -7.22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/xMark.6fafae365a1af63fb72b900813b4a757.svg";
export { ForwardRef as ReactComponent };